import { Grid, WithStyles, withStyles } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { userStyles } from "../styles";
import DialogLarge from "../common/DialogLarge";
import MyPATTab from "../../common/MyPATTab";
import MyPATTabs from "../../common/MyPATTabs";

interface ContentRequestDetailProps extends WithStyles<typeof userStyles> {
  isShowHeader?:boolean
}

interface ContentRequestDetailState {

}

class ContentRequestDetail extends Component<
    ContentRequestDetailProps,
    ContentRequestDetailState
> {
    constructor(props: ContentRequestDetailProps){
        super(props);
        this.state = {}
    }
    render(){
        const { classes } = this.props;
        return (
            <>
        <DialogLarge
          headerTitle="O-34RT567 | Content Request - Create Test"
          isFooter={false}
          isShowHeader={true}
        >
          <Grid>
          <MyPATTabs defaultSelected="My Task">
            <MyPATTab eventKey="CR Progress Timeline" isCustomCSS={true}>
            <Grid container justify="flex-start" className={classes.tabPanel}>
              //@Rittick : TODO add your MyPATStepper code 
             </Grid>
            </MyPATTab>
            <MyPATTab eventKey="Test Details & Order Notes" isCustomCSS={true}>
              <Grid className={classes.tabPanel}>
              Timeline- Data
              </Grid>
            </MyPATTab>
            </MyPATTabs>
          </Grid>
        </DialogLarge>
            </>
        )
    }
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withStyles(userStyles)(ContentRequestDetail));